import { Schema } from '../../utils/form';
import { FormattedMessage } from 'react-intl';
import React from 'react';

export default Schema.object({
  area: Schema.string().label(),
  areasSubordinadas: Schema.string(),
  nome: Schema.string().label(<FormattedMessage id="nome" />),
  idIntegracao: Schema.string().label(<FormattedMessage id="matricula" />),
  perfis: Schema.string().label(<FormattedMessage id="perfis" />),
  status: Schema.string().label(<FormattedMessage id="status" />),
  telefone: Schema.string().label(<FormattedMessage id="telefone" />),
  email: Schema.string().label(<FormattedMessage id="email" />),
  idioma: Schema.string().label(<FormattedMessage id="label.idioma" />),
  bloqueadoTentativaLogin: Schema.object().label(
    <FormattedMessage id="label.usuariosBloqueados" />
  ),
  emailBoasVindasEnviado: Schema.object().label(
    <FormattedMessage id="emailBoasVindasEnviado" />
  ),
  modulos: Schema.object().label(<FormattedMessage id="label.modulos" />),
  usuario: Schema.string().label(<FormattedMessage id="usuario" />),
  genero: Schema.string().label(<FormattedMessage id="genero" />),
  nomeSocial: Schema.string().label(<FormattedMessage id="nomeSocial" />),
  raca: Schema.string().label(<FormattedMessage id="raca" />),
  orientacaoSexual: Schema.string().label(
    <FormattedMessage id="orientacaoSexual" />
  ),
  nivelEducacional: Schema.string().label(
    <FormattedMessage id="nivelEducacional" />
  ),
  cursoFormacao: Schema.string().label(<FormattedMessage id="curso" />),
  instituicaoEnsino: Schema.string().label(
    <FormattedMessage id="instituicaoEnsino" />
  ),
  dataConclusaoFormacao: Schema.string().label(
    <FormattedMessage id="dataConclusao" />
  ),
  cargoExperiencia: Schema.string().label(<FormattedMessage id="cargo" />),
  empresaExperiencia: Schema.string().label(<FormattedMessage id="empresa" />),
  dataInicioExperiencia: Schema.string().label(
    <FormattedMessage id="dataInicio" />
  ),
  dataTerminoExperiencia: Schema.string().label(
    <FormattedMessage id="dataTermino" />
  ),
  cursoExtracurricular: Schema.string().label(<FormattedMessage id="curso" />),
  dataConclusaoExtracurricular: Schema.string().label(
    <FormattedMessage id="dataConclusao" />
  ),
  instituicaoExtracurricular: Schema.string().label(
    <FormattedMessage id="instituicaoEnsino" />
  ),
  idiomaCadastrado: Schema.string().label(<FormattedMessage id="idioma" />),
  nivelProficiencia: Schema.string().label(
    <FormattedMessage id="labelNivelProficiencia" />
  ),
  autorizacaoDivulgacaoAniversario: Schema.string().label(
    <FormattedMessage id="autorizacao" />
  ),
  interesseOutrasAreas: Schema.string().label(
    <FormattedMessage id="interesse" />
  ),
  areaInteresse: Schema.string().label(
    <FormattedMessage id="areasInteresse" />
  ),
  camposCustomizados: Schema.array(),
  disponibilidadeParaMudancas: Schema.string().label(
    <FormattedMessage id="disponibilidade" />
  ),
  localidadeDisponibilidade: Schema.string().label(
    <FormattedMessage id="localidade" />
  ),
  pais: Schema.string().label(<FormattedMessage id="pais" />),
});
